module.exports = __webpack_public_path__ + "static/media/dwarven-gold.e099e3f0.gif";